import DataService from './data-service';
import axios, { API_URL } from './http-service';
import { FetchOptions } from '../components/interfaces';

interface FetchDeviceOptions extends FetchOptions {
  unknown?: number;
}

interface UpdateUserData {
  userId: string;
  multiSensor?: boolean;
}

export default class DeviceService extends DataService {

  pureFetch = async (options?: FetchDeviceOptions) => {
    options = this.provideFetchOptions(options, { sort: 'log.dateTime', sortOrder: 'desc' });
    const url = API_URL + '/devices';
    return this.pureHandler(() => axios.get(url, { params: options }));
  }

  fetch = async () => {
    const url = API_URL + '/devices';
    return this.handler(() => axios.get(url));
  }

  findById = async (id: string) => {
    const url = API_URL + '/devices/' + id;
    return this.handler(() => axios.get(url));
  }

  update = async (id: string, index: number, data: any) => {
    const url = API_URL + '/devices/' + id + '/' + index;
    return this.handler(() => axios.put(url, data));
  }

  updateUser = async (deviceId: string, data: UpdateUserData) => {
    const url = API_URL + '/devices/' + deviceId + '/user';
    console.log(url, data);
    return this.handler(() => axios.put(url, data));
  }

  unAssignUser = async (deviceId: string) => {
    const url = API_URL + '/devices/' + deviceId + '/user';
    return this.handler(() => axios.delete(url));
  }

  assignRequest = async (deviceId: string) => {
    const url = API_URL + '/devices/' + deviceId + '/user';
    return this.handler(() => axios.delete(url));
  }

  remove = (id: string, hard = false) => {
    const url = `${API_URL}/devices/${id}?hard=` + hard;
    return this.handler(() => axios.delete(url));
  }

}
